import { render } from "./RuleLeadsView.vue?vue&type=template&id=f2848946"
import script from "./RuleLeadsView.vue?vue&type=script&lang=js"
export * from "./RuleLeadsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/RuleLeadsView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f2848946"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f2848946', __exports__)) {
    api.reload('f2848946', __exports__)
  }
  
  module.hot.accept("./RuleLeadsView.vue?vue&type=template&id=f2848946", () => {
    api.rerender('f2848946', render)
  })

}


export default __exports__